import React from "react";
import PropTypes from "prop-types";
import Layout from "../layout";
import errorGrey from "../../../assets/img/error-grey.png";
import "./css/index.scss";
import TooltipButton from "../tooltip-button";

const Error = ({ title, subtitle, text, image, email, role, pages, actions }) => {
  return (
    <Layout email={email} role={role} pages={pages}>
      <div className="container container-vhcenter">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <img src={image} alt="Imagen de error" className="col-4" />
          <h2 className="h2">{title}</h2>
          <h4 className="h4">{subtitle}</h4>
          <p>{text}</p>
          {actions.map(({ name, action, tooltip }) => (
            <TooltipButton
              key={name}
              buttonClassName="btn cp-btn__primary"
              onClick={() => action()}
              tooltipText={tooltip}
              buttonText={name}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

Error.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.element,
  email: PropTypes.string,
  role: PropTypes.string,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      active: PropTypes.bool
    })
  ),
  actions: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, action: PropTypes.func, tooltip: PropTypes.string })
  )
};

Error.defaultProps = {
  title: "Error",
  subtitle: "Ha habido un error",
  text: "Si el problema persiste consulte con el administrador",
  image: errorGrey,
  email: "",
  role: "",
  pages: [{ name: "Conciliaciones", path: "/", active: true }],
  actions: [
    {
      name: "Recargar",
      action: () => window.location.reload(),
      tooltip: "Volver a la página de inicio"
    }
  ]
};

export default Error;
